import axiosBase from '@/api/axiosBase'

const state = {
    userAvatar:'',//sessionStorage.getItem('userAvatar') ? sessionStorage.getItem('userAvatar') : '', //用户头像
    userAvatarChangeNum:-1,
    userInfo:null
}

const getters = {
    avatarChange:state=>state.userAvatarChangeNum
}

const actions = {
    //获取用户信息
    getUserInfo({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/user/get'
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                else{
                    commit('setUserInfo', res.data.data);
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
} 

const mutations = {
    setUserAvatar(state, avatar){
        state.userAvatarChangeNum += 1;
    },
    setUserInfo(state, _userInfo){
        state.userInfo = _userInfo;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}